<app-modal-dialog title="Accept onboarding information" (dismiss)="cancel()">

    <main>
        <app-layout-row>
            <app-layout-column [width]="12">
                <p>This will accept the information provided by the partner and create the relevant entities</p>
            </app-layout-column>
        </app-layout-row>
    </main>
   
    <footer>
      <div class="button-container">
        <app-button primary (buttonClick)="acceptAndCreate()">Accept and Create</app-button>
        <app-button secondary (buttonClick)="accept()">Accept - and create manually</app-button>
        <app-button secondary (buttonClick)="cancel()">Cancel</app-button>
      </div>
    </footer>
  
</app-modal-dialog>